<div
  class="relative bg-cover bg-center text-white flex items-center justify-center bg-[#FFF]"
>
  <div class="w-[100%]">
    <h4
      class="development-title pl-[104px] bg-[#F8F8F8] h-[100px] items-center justify-center pt-[25px]"
    >
      {{ projectName }}
    </h4>
    <div class="flex justify-end items-center pr-[37px]">
      <button (click)="handleClose()" class="close-button">Back</button>
    </div>
    <div
      class="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-6 gap-3 mt-[41px] p-5"
    >
      <div
        class="group"
        (click)="navigateToProjectRevision()"
        (mouseenter)="isHovering1 = true"
        (mouseleave)="isHovering1 = false"
      >
        <div
          class="transform group-hover:-translate-y-1 transition-transform duration-300 rounded-[10px] flex justify-center items-center flex-col cursor-pointer"
        >
          <img
            [src]="
              isHovering1
                ? 'assets/images/hover-project-brief&plan.png'
                : 'assets/images/project-brief&plan.png'
            "
            alt=""
            class="w-[120px] h-[120px]"
          />

          <p class="folder-title">Brief & Plan</p>
        </div>
      </div>

      <div
        class="group"
        (click)="navigateToProjectDesign()"
        (mouseenter)="isHovering2 = true"
        (mouseleave)="isHovering2 = false"
      >
        <div
          class="transform group-hover:-translate-y-1 transition-transform duration-300 rounded-[10px] flex justify-center items-center flex-col cursor-pointer"
        >
          <img
            [src]="
              isHovering2
                ? 'assets/images/hover-project-brief&plan.png'
                : 'assets/images/project-brief&plan.png'
            "
            alt=""
            class="w-[120px] h-[120px]"
          />

          <p class="folder-title">Design</p>
        </div>
      </div>

      <div
        class="group"
        (click)="navigateToTendering()"
        (mouseenter)="isHovering3 = true"
        (mouseleave)="isHovering3 = false"
      >
        <div
          class="transform group-hover:-translate-y-1 transition-transform duration-300 rounded-[10px] flex justify-center items-center flex-col cursor-pointer"
        >
          <img
            [src]="
              isHovering3
                ? 'assets/images/hover-project-brief&plan.png'
                : 'assets/images/project-brief&plan.png'
            "
            alt=""
            class="w-[120px] h-[120px]"
          />

          <p class="folder-title">Tendering</p>
        </div>
      </div>

      <div
        class="group"
        (mouseenter)="isHovering4 = true"
        (mouseleave)="isHovering4 = false"
      >
        <div
          class="transform group-hover:-translate-y-1 transition-transform duration-300 rounded-[10px] flex justify-center items-center flex-col cursor-pointer"
        >
          <img
            [src]="
              isHovering4
                ? 'assets/images/hover-project-brief&plan.png'
                : 'assets/images/project-brief&plan.png'
            "
            alt=""
            class="w-[120px] h-[120px]"
          />

          <p class="folder-title">Contracts</p>
        </div>
      </div>

      <div
        class="group"
        (mouseenter)="isHovering5 = true"
        (mouseleave)="isHovering5 = false"
      >
        <div
          class="transform group-hover:-translate-y-1 transition-transform duration-300 rounded-[10px] flex justify-center items-center flex-col cursor-pointer"
        >
          <img
            [src]="
              isHovering5
                ? 'assets/images/hover-project-brief&plan.png'
                : 'assets/images/project-brief&plan.png'
            "
            alt=""
            class="w-[120px] h-[120px]"
          />

          <p class="folder-title">Scope of Work</p>
        </div>
      </div>

      <div
        class="group"
        (mouseenter)="isHovering6 = true"
        (mouseleave)="isHovering6 = false"
      >
        <div
          class="transform group-hover:-translate-y-1 transition-transform duration-300 rounded-[10px] flex justify-center items-center flex-col cursor-pointer"
        >
          <img
            [src]="
              isHovering6
                ? 'assets/images/hover-project-brief&plan.png'
                : 'assets/images/project-brief&plan.png'
            "
            alt=""
            class="w-[120px] h-[120px]"
          />

          <p class="folder-title">Insurance</p>
        </div>
      </div>

      <div
        class="group"
        (mouseenter)="isHovering7 = true"
        (mouseleave)="isHovering7 = false"
      >
        <div
          class="transform group-hover:-translate-y-1 transition-transform duration-300 rounded-[10px] flex justify-center items-center flex-col cursor-pointer"
        >
          <img
            [src]="
              isHovering7
                ? 'assets/images/hover-project-brief&plan.png'
                : 'assets/images/project-brief&plan.png'
            "
            alt=""
            class="w-[120px] h-[120px]"
          />

          <p class="folder-title">Vendors</p>
        </div>
      </div>

      <div
        class="group"
        (mouseenter)="isHovering8 = true"
        (mouseleave)="isHovering8 = false"
      >
        <div
          class="transform group-hover:-translate-y-1 transition-transform duration-300 rounded-[10px] flex justify-center items-center flex-col cursor-pointer"
        >
          <img
            [src]="
              isHovering8
                ? 'assets/images/hover-project-brief&plan.png'
                : 'assets/images/project-brief&plan.png'
            "
            alt=""
            class="w-[120px] h-[120px]"
          />

          <p class="folder-title">Payment</p>
        </div>
      </div>

      <div
        class="group"
        (mouseenter)="isHovering9 = true"
        (mouseleave)="isHovering9 = false"
      >
        <div
          class="transform group-hover:-translate-y-1 transition-transform duration-300 rounded-[10px] flex justify-center items-center flex-col cursor-pointer"
        >
          <img
            [src]="
              isHovering9
                ? 'assets/images/hover-project-brief&plan.png'
                : 'assets/images/project-brief&plan.png'
            "
            alt=""
            class="w-[120px] h-[120px]"
          />

          <p class="folder-title">Changes</p>
        </div>
      </div>

      <div
        class="group"
        (mouseenter)="isHovering10 = true"
        (mouseleave)="isHovering10 = false"
      >
        <div
          class="transform group-hover:-translate-y-1 transition-transform duration-300 rounded-[10px] flex justify-center items-center flex-col cursor-pointer"
        >
          <img
            [src]="
              isHovering10
                ? 'assets/images/hover-project-brief&plan.png'
                : 'assets/images/project-brief&plan.png'
            "
            alt=""
            class="w-[120px] h-[120px]"
          />

          <p class="folder-title">Program</p>
        </div>
      </div>

      <div
        class="group"
        (mouseenter)="isHovering11 = true"
        (mouseleave)="isHovering11 = false"
      >
        <div
          class="transform group-hover:-translate-y-1 transition-transform duration-300 rounded-[10px] flex justify-center items-center flex-col cursor-pointer"
        >
          <img
            [src]="
              isHovering11
                ? 'assets/images/hover-project-brief&plan.png'
                : 'assets/images/project-brief&plan.png'
            "
            alt=""
            class="w-[120px] h-[120px]"
          />

          <p class="folder-title">Health & Safety</p>
        </div>
      </div>

      <div
        class="group"
        (mouseenter)="isHovering12 = true"
        (mouseleave)="isHovering12 = false"
      >
        <div
          class="transform group-hover:-translate-y-1 transition-transform duration-300 rounded-[10px] flex justify-center items-center flex-col cursor-pointer"
        >
          <img
            [src]="
              isHovering12
                ? 'assets/images/hover-project-brief&plan.png'
                : 'assets/images/project-brief&plan.png'
            "
            alt=""
            class="w-[120px] h-[120px]"
          />

          <p class="folder-title">Operations Report</p>
        </div>
      </div>

      <div
        class="group"
        (mouseenter)="isHovering13 = true"
        (mouseleave)="isHovering13 = false"
      >
        <div
          class="transform group-hover:-translate-y-1 transition-transform duration-300 rounded-[10px] flex justify-center items-center flex-col cursor-pointer"
        >
          <img
            [src]="
              isHovering13
                ? 'assets/images/hover-project-brief&plan.png'
                : 'assets/images/project-brief&plan.png'
            "
            alt=""
            class="w-[120px] h-[120px]"
          />

          <p class="folder-title">RFI</p>
        </div>
      </div>
    </div>
  </div>
</div>
